import React from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal, useMsalAuthentication } from '@azure/msal-react';
import { ERROR_USER_CANCELLED } from './errors';
import { InteractionType } from '@azure/msal-browser';

var Redirect = () => {
  // todo redirect after a timeout? or add a message to redirect after a timeout?
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};

export var Login = _ref => {
  var _instance$getActiveAc;

  var {
    clientId,
    scope,
    loadingErrorView: LoadingErrorView
  } = _ref;
  var {
    instance
  } = useMsal();
  var {
    error
  } = useMsalAuthentication(InteractionType.Redirect, {
    scopes: [scope]
  }, {
    homeAccountId: (_instance$getActiveAc = instance.getActiveAccount()) === null || _instance$getActiveAc === void 0 ? void 0 : _instance$getActiveAc.homeAccountId
  });

  if ((error === null || error === void 0 ? void 0 : error.errorCode) === 'access_denied' && // this is the way the msal libraries check the error type
  error.errorMessage.includes(ERROR_USER_CANCELLED)) {
    // the cancel error code comes when people try to cancel signing up or
    // resetting a password, so it should go back to the login page
    sessionStorage.removeItem("msal.".concat(clientId, ".request.origin"));
    localStorage.removeItem("msal.".concat(clientId, ".request.origin")); // display LoadingErrorView while it redirects back to the login page.

    return /*#__PURE__*/React.createElement(UnauthenticatedTemplate, null, /*#__PURE__*/React.createElement(LoadingErrorView, {
      error: error
    }));
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AuthenticatedTemplate, null, /*#__PURE__*/React.createElement(Redirect, null)), /*#__PURE__*/React.createElement(UnauthenticatedTemplate, null, /*#__PURE__*/React.createElement(LoadingErrorView, {
    error: error
  })));
};